import i18n from "../i18n";

const Theme = (app) => {
  app.post("/theme", async ({ req, res, api, flash, locals }) => {
    const { body } = req;
    body.action = "updateUserPreferences";
    const { isFromChat = false } = body;
    await api(`theme`, {
      method: "POST",
      body,
    }).then((response) => {
      if (response.error) {
        flash("error", response.error);
        return res.back();
      }
      flash(
        "success",
        i18n.t("coaching-portal:themeActions.successfullyUpdated")
      );
    });
    //if the user changes the theme meanwhile is located in the chat is important to refresh with the groupEdited param
    if (isFromChat) {
      return res.refreshWith({ groupEdited: true }, { url: "back" });
    } else {
      res.backDontScroll();
    }
  });
};
export default Theme;
